import type { ProjectId } from 'owa-timestream-types';
import getAssets from './getAssets';
import isCapturedAsset from './isCapturedAsset';

export default function getCapturedAssets(projectId: ProjectId) {
    return getAssets(projectId).filter(([id, asset]) => isCapturedAsset(asset));
}
